export var CofaceAccountName;
(function (CofaceAccountName) {
    CofaceAccountName["Main"] = "coface";
    CofaceAccountName["Servyr"] = "servyr";
})(CofaceAccountName || (CofaceAccountName = {}));
